import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

type Callback = () => void | Promise<void>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEffectOnMount(callback: EffectCallback | any) {
  // TODO: revisar tipo del callback

  useEffect(() => {
    callback();
  }, []);
}

export function useEffectOnUpdate(callback: Callback, dependencies: DependencyList) {
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    callback();
  }, dependencies);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEffectOnUnmount(callback: ReturnType<EffectCallback> | any) {
  // TODO revisar tipo del callback
  useEffect(() => callback, []);
}
